import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import { FaArrowLeft, FaCar, FaUser, FaCalendarAlt, FaMoneyBillWave, FaFileUpload, FaTachometerAlt, FaGasPump, FaCheckCircle, FaIdCard, FaPhone } from 'react-icons/fa';

export default function Alquilar({ goBack }) {
    const [vehiculos, setVehiculos] = useState([]);
    const [step, setStep] = useState(1);
    const [selectedCar, setSelectedCar] = useState(null);

    const [form, setForm] = useState({
        cliente_nombre: '', 
        cliente_ci: '', 
        cliente_telefono: '',
        fecha_inicio: '', 
        fecha_fin: '', 
        garantia: '', 
        observaciones: '',
        precio_dia_acordado: 0,
        documento: null
    });

    const [checkIn, setCheckIn] = useState({ km: '', gasolina: 'Full' });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/vehiculos');
            setVehiculos(res.data.filter(v => v.estado === 'libre'));
        } catch (error) { console.error(error); }
    };

    const handleSelectCar = (car) => {
        setSelectedCar(car);
        setForm(prev => ({ ...prev, precio_dia_acordado: car.precio_dia })); 
        setCheckIn(prev => ({ ...prev, km: car.kilometraje_actual || 0 }));
        setStep(2);
    };

    const calcularTotal = () => {
        if (!form.fecha_inicio || !form.fecha_fin) return 0;
        const diff = new Date(form.fecha_fin) - new Date(form.fecha_inicio);
        const dias = Math.ceil(diff / (1000 * 60 * 60 * 24));
        return dias > 0 ? dias * form.precio_dia_acordado : 0;
    };

    const calcularDias = () => {
        if (!form.fecha_inicio || !form.fecha_fin) return 0;
        const diff = new Date(form.fecha_fin) - new Date(form.fecha_inicio);
        return Math.ceil(diff / (1000 * 60 * 60 * 24));
    };

    // GENERAR CONTRATO PDF MEJORADO
    const generarContratoPDF = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        
        // === ENCABEZADO CON DISEÑO MODERNO ===
        // Fondo del header
        doc.setFillColor(34, 139, 34); // Verde
        doc.rect(0, 0, pageWidth, 45, 'F');
        
        // Logo/Icono simulado
        doc.setFillColor(255, 255, 255);
        doc.circle(30, 22, 12, 'F');
        doc.setFillColor(34, 139, 34);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text('AC', 30, 25, { align: 'center' });
        
        // Título empresa
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(24);
        doc.text('ALQUILACAR S.R.L.', 50, 20);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('Alquiler de Vehículos Premium', 50, 28);
        doc.text('www.alquilacar.com | info@alquilacar.com', 50, 34);
        
        // Número de contrato en badge
        doc.setFillColor(255, 215, 0); // Dorado
        doc.roundedRect(pageWidth - 55, 10, 45, 12, 2, 2, 'F');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        const contratoNum = Date.now().toString().slice(-8);
        doc.text(`N° ${contratoNum}`, pageWidth - 32.5, 18, { align: 'center' });
        
        // Fecha
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Fecha: ${new Date().toLocaleDateString('es-ES')}`, pageWidth - 32.5, 30, { align: 'center' });
        
        // === TÍTULO DOCUMENTO ===
        doc.setTextColor(34, 139, 34);
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text('CONTRATO DE ARRENDAMIENTO', pageWidth / 2, 60, { align: 'center' });
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('DE VEHÍCULO AUTOMOTOR', pageWidth / 2, 67, { align: 'center' });
        
        // === SECCIÓN 1: PARTES ===
        let yPos = 80;
        
        // Box para las partes
        doc.setDrawColor(34, 139, 34);
        doc.setLineWidth(0.5);
        doc.roundedRect(15, yPos, pageWidth - 30, 45, 3, 3);
        
        doc.setFillColor(34, 139, 34);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('I. PARTES CONTRATANTES', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text('ARRENDADOR:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text('ALQUILACAR S.R.L.', 50, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('ARRENDATARIO:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(form.cliente_nombre.toUpperCase(), 50, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('CI/DNI:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(form.cliente_ci || 'N/A', 50, yPos);
        doc.setFont("helvetica", "bold");
        doc.text('TELÉFONO:', 110, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(form.cliente_telefono || 'N/A', 135, yPos);
        
        // === SECCIÓN 2: VEHÍCULO ===
        yPos += 15;
        doc.setDrawColor(34, 139, 34);
        doc.roundedRect(15, yPos, pageWidth - 30, 50, 3, 3);
        
        doc.setFillColor(34, 139, 34);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('II. VEHÍCULO ARRENDADO', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        // Primera fila
        doc.setFont("helvetica", "bold");
        doc.text('MARCA:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(selectedCar.marca, 40, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('MODELO:', 90, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(selectedCar.modelo, 110, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('AÑO:', 150, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(selectedCar.anio.toString(), 165, yPos);
        
        yPos += 8;
        doc.setFont("helvetica", "bold");
        doc.text('PLACA:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(selectedCar.placa, 40, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('COLOR:', 90, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(selectedCar.color, 110, yPos);
        
        // Estado de entrega
        yPos += 12;
        doc.setFillColor(240, 248, 255);
        doc.roundedRect(18, yPos - 3, pageWidth - 36, 18, 2, 2, 'F');
        
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(34, 139, 34);
        doc.text('CONDICIONES DE ENTREGA:', 22, yPos + 2);
        
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        yPos += 8;
        doc.text(`Kilometraje: ${checkIn.km} KM`, 22, yPos);
        doc.text(`Combustible: ${checkIn.gasolina}`, 100, yPos);
        
        // === SECCIÓN 3: CONDICIONES ===
        yPos += 15;
        doc.setDrawColor(34, 139, 34);
        doc.roundedRect(15, yPos, pageWidth - 30, 55, 3, 3);
        
        doc.setFillColor(34, 139, 34);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('III. CONDICIONES ECONÓMICAS Y PLAZO', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        const dias = calcularDias();
        const total = calcularTotal();
        
        doc.setFont("helvetica", "bold");
        doc.text('FECHA INICIO:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(new Date(form.fecha_inicio).toLocaleDateString('es-ES'), 55, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('FECHA FIN:', 110, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(new Date(form.fecha_fin).toLocaleDateString('es-ES'), 138, yPos);
        
        yPos += 8;
        doc.setFont("helvetica", "bold");
        doc.text('DÍAS TOTALES:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(dias.toString(), 55, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('TARIFA DIARIA:', 110, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(`Bs. ${parseFloat(form.precio_dia_acordado).toFixed(2)}`, 138, yPos);
        
        yPos += 8;
        doc.setFont("helvetica", "bold");
        doc.text('GARANTÍA:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(`Bs. ${parseFloat(form.garantia || 0).toFixed(2)}`, 55, yPos);
        
        // Total destacado
        yPos += 12;
        doc.setFillColor(255, 215, 0);
        doc.roundedRect(18, yPos - 5, pageWidth - 36, 12, 2, 2, 'F');
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(`TOTAL A PAGAR: Bs. ${total.toFixed(2)}`, pageWidth / 2, yPos + 2, { align: 'center' });
        
        // === CLÁUSULAS ===
        yPos += 18;
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(34, 139, 34);
        doc.text('CLÁUSULAS Y CONDICIONES:', 15, yPos);
        
        yPos += 5;
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        
        const clausulas = [
            '1. El arrendatario declara haber recibido el vehículo en perfectas condiciones de funcionamiento y se compromete a devolverlo en el mismo estado.',
            '2. Cualquier daño, multa o infracción de tránsito durante el período de alquiler será responsabilidad exclusiva del arrendatario.',
            '3. El arrendatario se compromete a usar el vehículo de forma responsable y conforme a la ley.',
            '4. La garantía será devuelta al término del contrato, previa inspección satisfactoria del vehículo.'
        ];
        
        clausulas.forEach(clausula => {
            const lines = doc.splitTextToSize(clausula, pageWidth - 30);
            doc.text(lines, 15, yPos);
            yPos += lines.length * 4;
        });
        
        // Pie de página
        doc.setFontSize(7);
        doc.setTextColor(128, 128, 128);
        doc.text('Este documento es un contrato legalmente vinculante. Conserve una copia para sus registros.', pageWidth / 2, pageHeight - 10, { align: 'center' });
        
        doc.save(`Contrato_${form.cliente_nombre.replace(/\s+/g, '_')}_${contratoNum}.pdf`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const total = calcularTotal();
        if(total <= 0) return Swal.fire('Error', 'Fechas inválidas', 'error');

        const formData = new FormData();
        formData.append('vehiculo_id', selectedCar.id);
        formData.append('cliente_nombre', form.cliente_nombre);
        formData.append('cliente_ci', form.cliente_ci);
        formData.append('cliente_telefono', form.cliente_telefono);
        formData.append('fecha_inicio', form.fecha_inicio);
        formData.append('fecha_fin', form.fecha_fin);
        formData.append('total', total);
        formData.append('garantia', form.garantia);
        formData.append('observaciones', form.observaciones);
        formData.append('precio_dia_acordado', form.precio_dia_acordado);
        formData.append('km_salida', checkIn.km);
        formData.append('gasolina_salida', checkIn.gasolina);

        if(form.documento) formData.append('documento', form.documento);

        try {
            await axios.post('https://api.alquilacarbolivia.com/api/operaciones/rentar', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            generarContratoPDF();

            Swal.fire({
                title: '¡Alquiler Exitoso!',
                html: '<p class="mb-2">El contrato ha sido registrado exitosamente.</p><p class="text-success fw-bold">✓ Contrato PDF generado</p>',
                icon: 'success',
                confirmButtonColor: '#228B22'
            }).then(() => {
                goBack();
            });
            
        } catch (error) { 
            Swal.fire('Error', 'No se pudo registrar el alquiler', 'error'); 
        }
    };

    return (
        <div className="min-vh-100" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
            {/* HEADER MEJORADO */}
            <div className="shadow-lg" style={{ 
                background: 'linear-gradient(135deg, #228B22 0%, #32CD32 100%)',
                padding: '1.5rem'
            }}>
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-3">
                            <button 
                                className="btn btn-light shadow-sm hover-lift" 
                                onClick={step === 1 ? goBack : () => setStep(1)}
                                style={{ borderRadius: '10px', fontWeight: '600' }}
                            >
                                <FaArrowLeft className="me-2" />
                                {step === 1 ? 'Volver al Menú' : 'Cambiar Vehículo'}
                            </button>
                            <div className="text-white">
                                <h3 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                    <FaCar />
                                    NUEVO ALQUILER
                                </h3>
                                <small style={{ opacity: 0.9 }}>Sistema de gestión de rentas</small>
                            </div>
                        </div>
                        
                        {/* Indicador de paso */}
                        <div className="d-none d-md-flex align-items-center gap-3 text-white">
                            <div className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${step === 1 ? 'bg-white text-success' : 'bg-success bg-opacity-25'}`} style={{ fontWeight: '600' }}>
                                <div style={{ 
                                    width: '30px', 
                                    height: '30px', 
                                    borderRadius: '50%', 
                                    background: step === 1 ? '#228B22' : 'rgba(255,255,255,0.3)',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>1</div>
                                <span>Selección</span>
                            </div>
                            <div style={{ width: '50px', height: '2px', background: 'rgba(255,255,255,0.4)' }}></div>
                            <div className={`d-flex align-items-center gap-2 px-3 py-2 rounded ${step === 2 ? 'bg-white text-success' : 'bg-success bg-opacity-25'}`} style={{ fontWeight: '600' }}>
                                <div style={{ 
                                    width: '30px', 
                                    height: '30px', 
                                    borderRadius: '50%', 
                                    background: step === 2 ? '#228B22' : 'rgba(255,255,255,0.3)',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>2</div>
                                <span>Registro</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-4">
                {step === 1 ? (
                    <div>
                        <div className="mb-4">
                            <h4 className="fw-bold text-dark mb-1">Vehículos Disponibles</h4>
                            <p className="text-muted">Seleccione el vehículo que desea rentar</p>
                        </div>
                        
                        <div className="row g-4">
                            {vehiculos.map(car => (
                                <div key={car.id} className="col-lg-3 col-md-4 col-sm-6">
                                    <div 
                                        className="card h-100 border-0 shadow-sm position-relative overflow-hidden"
                                        onClick={() => handleSelectCar(car)} 
                                        style={{
                                            cursor: 'pointer',
                                            borderRadius: '15px',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={e => {
                                            e.currentTarget.style.transform = 'translateY(-10px)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(34,139,34,0.3)';
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '';
                                        }}
                                    >
                                        {/* Badge disponible */}
                                        <div className="position-absolute top-0 end-0 m-3 z-3">
                                            <span className="badge bg-success shadow-sm" style={{ fontSize: '0.7rem' }}>
                                                <FaCheckCircle className="me-1" />
                                                Disponible
                                            </span>
                                        </div>
                                        
                                        {/* Imagen */}
                                        <div style={{
                                            height: '200px',
                                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                            position: 'relative',
                                            overflow: 'hidden'
                                        }}>
                                            {car.imagen_url ? (
                                                <img 
                                                    src={car.imagen_url} 
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover'
                                                    }} 
                                                    alt={`${car.marca} ${car.modelo}`}
                                                />
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center h-100">
                                                    <FaCar style={{ fontSize: '4rem', color: 'rgba(255,255,255,0.5)' }} />
                                                </div>
                                            )}
                                        </div>
                                        
                                        {/* Contenido */}
                                        <div className="card-body">
                                            <h5 className="fw-bold mb-2">{car.marca} {car.modelo}</h5>
                                            <p className="text-muted small mb-3">
                                                <FaIdCard className="me-1" />
                                                Placa: {car.placa}
                                            </p>
                                            
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <span className="text-muted small">
                                                    <FaTachometerAlt className="me-1 text-primary" />
                                                    {car.kilometraje_actual || 0} KM
                                                </span>
                                                <span className="text-muted small">{car.anio}</span>
                                            </div>
                                            
                                            <div className="d-flex justify-content-between align-items-center pt-3 border-top">
                                                <span className="text-muted small">Tarifa diaria</span>
                                                <div className="d-flex align-items-center gap-1">
                                                    <FaMoneyBillWave className="text-success" />
                                                    <span className="fw-bold fs-5 text-success">Bs. {car.precio_dia}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                            {vehiculos.length === 0 && (
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                                        <div className="card-body text-center py-5">
                                            <FaCar style={{ fontSize: '4rem', color: '#ddd', marginBottom: '1rem' }} />
                                            <h5 className="text-muted">No hay vehículos disponibles</h5>
                                            <p className="text-muted small">En este momento todos los vehículos están rentados.</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="row justify-content-center">
                        <div className="col-xl-10">
                            {/* Card del vehículo seleccionado */}
                            <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                <div style={{
                                    background: 'linear-gradient(135deg, #228B22 0%, #32CD32 100%)',
                                    padding: '1.5rem',
                                    color: 'white'
                                }}>
                                    <div className="row align-items-center">
                                        <div className="col-md-8">
                                            <h4 className="fw-bold mb-2">
                                                <FaCar className="me-2" />
                                                {selectedCar.marca} {selectedCar.modelo}
                                            </h4>
                                            <div className="d-flex gap-4 flex-wrap">
                                                <span><strong>Placa:</strong> {selectedCar.placa}</span>
                                                <span><strong>Año:</strong> {selectedCar.anio}</span>
                                                <span><strong>Color:</strong> {selectedCar.color}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 text-md-end mt-3 mt-md-0">
                                            <div className="badge bg-warning text-dark px-3 py-2" style={{ fontSize: '1.1rem' }}>
                                                Bs. {selectedCar.precio_dia} / día
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Formulario */}
                            <form onSubmit={handleSubmit}>
                                {/* Datos del Cliente */}
                                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold d-flex align-items-center gap-2 text-success mb-0">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #228B22 0%, #32CD32 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white'
                                            }}>
                                                <FaUser />
                                            </div>
                                            Datos del Cliente
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <FaUser className="me-2 text-success" />
                                                    Nombre Completo *
                                                </label>
                                                <input 
                                                    className="form-control form-control-lg" 
                                                    required 
                                                    placeholder="Ej: Juan Pérez González"
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, cliente_nombre: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-semibold">
                                                    <FaIdCard className="me-2 text-success" />
                                                    CI / DNI
                                                </label>
                                                <input 
                                                    className="form-control form-control-lg" 
                                                    placeholder="Ej: 12345678"
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, cliente_ci: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-semibold">
                                                    <FaPhone className="me-2 text-success" />
                                                    Teléfono
                                                </label>
                                                <input 
                                                    className="form-control form-control-lg" 
                                                    placeholder="Ej: 70123456"
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, cliente_telefono: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">
                                                    <FaFileUpload className="me-2 text-success" />
                                                    Adjuntar Licencia / Documentos (Opcional)
                                                </label>
                                                <input 
                                                    type="file" 
                                                    className="form-control form-control-lg" 
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, documento: e.target.files[0]})} 
                                                />
                                                <small className="text-muted">Formatos aceptados: PDF, JPG, PNG</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Estado de Entrega */}
                                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold d-flex align-items-center gap-2 text-primary mb-0">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white'
                                            }}>
                                                <FaTachometerAlt />
                                            </div>
                                            Estado de Entrega (Check-in)
                                        </h5>
                                    </div>
                                    <div className="card-body p-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <FaTachometerAlt className="me-2 text-primary" />
                                                    Kilometraje de Salida *
                                                </label>
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-lg" 
                                                    required 
                                                    value={checkIn.km} 
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setCheckIn({...checkIn, km: e.target.value})} 
                                                />
                                                <small className="text-muted">
                                                    <FaCheckCircle className="me-1 text-success" />
                                                    Actual en sistema: {selectedCar.kilometraje_actual} KM
                                                </small>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">
                                                    <FaGasPump className="me-2 text-primary" />
                                                    Nivel de Gasolina *
                                                </label>
                                                <select 
                                                    className="form-select form-select-lg" 
                                                    value={checkIn.gasolina} 
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setCheckIn({...checkIn, gasolina: e.target.value})}
                                                >
                                                    <option value="Full">🟢 Tanque Lleno (Full)</option>
                                                    <option value="3/4">🟡 3/4 Tanque</option>
                                                    <option value="1/2">🟠 1/2 Tanque</option>
                                                    <option value="1/4">🟠 1/4 Tanque</option>
                                                    <option value="Reserva">🔴 Reserva</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Detalles del Alquiler */}
                                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px' }}>
                                    <div className="card-header bg-white border-0 pt-4 px-4">
                                        <h5 className="fw-bold d-flex align-items-center gap-2 text-warning mb-0">
                                            <div style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white'
                                            }}>
                                                <FaCalendarAlt />
                                            </div>
                                            Detalles del Alquiler
                                        </h5>
                                    </div>
                                    <div className="card-body p-4">
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <label className="form-label fw-semibold">
                                                    <FaCalendarAlt className="me-2 text-warning" />
                                                    Fecha Inicio *
                                                </label>
                                                <input 
                                                    type="date" 
                                                    className="form-control form-control-lg" 
                                                    required 
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, fecha_inicio: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-semibold">
                                                    <FaCalendarAlt className="me-2 text-warning" />
                                                    Fecha Fin *
                                                </label>
                                                <input 
                                                    type="date" 
                                                    className="form-control form-control-lg" 
                                                    required 
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, fecha_fin: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-semibold">
                                                    <FaMoneyBillWave className="me-2 text-success" />
                                                    Precio/Día (Bs) *
                                                </label>
                                                <input 
                                                    type="number" 
                                                    step="0.50" 
                                                    className="form-control form-control-lg border-success" 
                                                    value={form.precio_dia_acordado} 
                                                    style={{ borderRadius: '10px', borderWidth: '2px' }}
                                                    onChange={e => setForm({...form, precio_dia_acordado: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label fw-semibold">
                                                    <FaMoneyBillWave className="me-2 text-info" />
                                                    Garantía (Bs)
                                                </label>
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-lg" 
                                                    placeholder="0.00"
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, garantia: e.target.value})} 
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-semibold">Observaciones Adicionales</label>
                                                <textarea 
                                                    className="form-control" 
                                                    placeholder="Ingrese cualquier observación relevante sobre el alquiler..."
                                                    rows="3" 
                                                    style={{ borderRadius: '10px' }}
                                                    onChange={e => setForm({...form, observaciones: e.target.value})}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Resumen Total */}
                                <div className="card border-0 shadow-lg mb-4" style={{
                                    borderRadius: '15px',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: 'white'
                                }}>
                                    <div className="card-body p-4">
                                        <div className="row align-items-center">
                                            <div className="col-md-8">
                                                <h6 className="mb-2 opacity-75">RESUMEN DEL ALQUILER</h6>
                                                <div className="d-flex gap-4 flex-wrap">
                                                    <div>
                                                        <small className="opacity-75">Días:</small>
                                                        <div className="fw-bold fs-5">{calcularDias()}</div>
                                                    </div>
                                                    <div>
                                                        <small className="opacity-75">Tarifa/Día:</small>
                                                        <div className="fw-bold fs-5">Bs. {parseFloat(form.precio_dia_acordado || 0).toFixed(2)}</div>
                                                    </div>
                                                    <div>
                                                        <small className="opacity-75">Garantía:</small>
                                                        <div className="fw-bold fs-5">Bs. {parseFloat(form.garantia || 0).toFixed(2)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 text-md-end mt-3 mt-md-0">
                                                <small className="opacity-75 d-block mb-1">TOTAL A PAGAR</small>
                                                <h2 className="mb-0 fw-bold">Bs. {calcularTotal().toFixed(2)}</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Botón Submit */}
                                <button 
                                    type="submit" 
                                    className="btn btn-lg w-100 text-white fw-bold shadow-lg"
                                    style={{
                                        borderRadius: '15px',
                                        padding: '1rem',
                                        fontSize: '1.2rem',
                                        background: 'linear-gradient(135deg, #228B22 0%, #32CD32 100%)',
                                        border: 'none',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={e => e.target.style.transform = 'scale(1.02)'}
                                    onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                                >
                                    <FaCheckCircle className="me-2" />
                                    CONFIRMAR ALQUILER Y GENERAR CONTRATO
                                </button>
                                
                                <p className="text-center text-muted mt-3 small">
                                    <FaFileUpload className="me-1" />
                                    El contrato en PDF se descargará automáticamente
                                </p>
                            </form>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                .hover-lift {
                    transition: all 0.3s ease;
                }
                .hover-lift:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }
                
                .form-control:focus,
                .form-select:focus {
                    border-color: #228B22;
                    box-shadow: 0 0 0 0.2rem rgba(34, 139, 34, 0.25);
                }
            `}</style>
        </div>
    );
}